(function($) {

  var Price = function(element) {

    var baseClass = 'price-list';
    var element = $(element);
    var groups = element.find('.' + baseClass + '__group');

    groups.addClass(baseClass + '__group--collapsed');
    $(groups.get(0)).removeClass(baseClass + '__group--collapsed');

    element
      .find('.' + baseClass + '__heading-row')
      .addClass(baseClass + '__heading-row--collapsed');

    element
      .find('.' + baseClass + '__heading-row[data-category="' + $(groups.get(0)).attr('data-category') + '"]')
      .removeClass(baseClass + '__heading-row--collapsed');



    var isMobile = function() {
      return element.find('.' + baseClass + '__heading-row').find('.' + baseClass + '__name-col').css('text-align') == 'center'
    }

    $('.' + baseClass + '__heading-row').click(function() {
      if(!isMobile()) return;

      var group = element.find('.' + baseClass + '__group[data-category="' + $(this).attr('data-category') + '"]');

      if(group.hasClass(baseClass + '__group--collapsed')) {
        group.removeClass(baseClass + '__group--collapsed');
        $(this).removeClass(baseClass + '__heading-row--collapsed');
      } else {
        group.addClass(baseClass + '__group--collapsed');
        $(this).addClass(baseClass + '__heading-row--collapsed');
      }

    });
  };

  $(document).ready(function() {
    new Price($('.price-list'));
  });

})(jQuery);
